import { AppSettings } from './../../proyect.conf';
import { UsuarioComisionFreelanceHistorico } from './../_models/usuario-comision-freelance-historico';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsuarioComisionFreelanceHistoricoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/usuariosComisionesFreelanceHistoricos';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as UsuarioComisionFreelanceHistorico[] ) );
  }

  listadoHabilitados() {
    return this.httpClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as UsuarioComisionFreelanceHistorico[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as UsuarioComisionFreelanceHistorico ) );
  }

  listadoPorUsuarioFreelance( id: string ) {
    return this.httpClient.get( this.rutServicio + '/usuarioComision/' + id + '/enabled' ).pipe( map( res => res as UsuarioComisionFreelanceHistorico[] ) );
  }

  crear( regCrear: UsuarioComisionFreelanceHistorico ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.idUsuarioModifica = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as UsuarioComisionFreelanceHistorico ) );
  }

  actualizar( regActualizar: UsuarioComisionFreelanceHistorico ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regActualizar.idUsuarioModifica = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: UsuarioComisionFreelanceHistorico[] ): Observable<UsuarioComisionFreelanceHistorico[]> {
    regActualizar.map( ( s: UsuarioComisionFreelanceHistorico ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
      s.idUsuarioModifica = this.autServicio.obtenerIdUsuarioLogueado();
      s.ipLocal = localStorage.getItem('ipLocal');
      s.ipPublica = localStorage.getItem('ipClient');
    } );
    return this.httpClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as UsuarioComisionFreelanceHistorico[] ) );
  }

}
